import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { SpinoffAuthService } from '@sbe-spinoff-client/spinoff-platform';
import { BootGateService } from './boot-gate.service';

// authGuard와 동일한 이유(app.config.ts가 더 이상 부트스트랩을 블로킹하지 않음)로 부팅
// 시퀀스 완료를 기다린다 — 안 그러면 이미 로그인된 사용자가 콜드 진입 시 로그인 화면을
// 잠깐 보게 된다(리다이렉트가 안 걸리는 채로 통과).
export const redirectIfLoggedInGuard: CanActivateFn = async () => {
  const auth = inject(SpinoffAuthService);
  const bootGate = inject(BootGateService);
  const router = inject(Router);
  await bootGate.whenReady();
  if (auth.isAuthenticated()) return router.createUrlTree(['/']);
  return true;
};
